import { ICreateProcessoIndicadoresUseCase } from "../../../presentation/useCases/create/create_processo_indicador_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// CreateProcessoIndicadorUseCase

export class CreateItemProcessoIndicadorUseCase implements ICreateProcessoIndicadoresUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async createProcesoIndicadores(IdItemProcessoIndicador: number, IdItemProcesso: number,  IdIndicador: number[]
  ): Promise<void> {
    await this.repository.createProcesoIndicadores(IdItemProcessoIndicador, IdItemProcesso, IdIndicador);
  }
}